import { createFileRoute } from "@tanstack/react-router";
import { DirectSSHInstance } from "../../features/spot/instance";
import { WorkspaceDetail } from "../../features/workspaces/workspace-detail";

export const Route = createFileRoute("/_authed/$org/$project/instances/$name/$tab")({
  validateSearch: (s: Record<string, unknown>): { connect?: string; focus?: string } => ({
    ...(s.connect === "ssh" ? { connect: "ssh" } : {}),
    ...(s.focus === "spec.maxCostUSD" ? { focus: "spec.maxCostUSD" } : {}),
  }),
  component: WorkspacePage,
});

function WorkspacePage() {
  const { org, project, name, tab } = Route.useParams();
  const { connect } = Route.useSearch();
  if (name.startsWith("spot_")) return <DirectSSHInstance scope={{ org, project }} id={name} />;
  return <WorkspaceDetail key={JSON.stringify([org, project, name])} mode="instance" scope={{ org, project }} name={name} tab={tab} {...(connect ? { connect } : {})} />;
}
